var React = require('react');
var ReactNative = require('react-native');
var Animated = require('./wrappers/Animated');
var createReactClass = require('create-react-class');
var {
  View,
  StyleSheet,
} = ReactNative;

const OFFSET_VIEW_SCROLL_TIMING = 400;

var OffsetView = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      horizontal:false,
      style:{},
      children:null
    }
  },

  getInitialState : function()
  {
    return {
      offsetX : new Animated.Value(0),
      offsetY : new Animated.Value(0),
    }
  },

  componentWillReceiveProps: function(newProps)
  {
  },

  _completion: null,
  scrollTo: function(info)
  {
    var animated = typeof info.animated !== 'undefined' ? info.animated : false;
    var offsetX = typeof info.x !== 'undefined' ? -info.x : null;
    var offsetY = typeof info.y !== 'undefined' ? -info.y : null;
    if( typeof info.completion !== 'undefined' ) this._completion = info.completion;
    else this._completion = null;

    var duration = OFFSET_VIEW_SCROLL_TIMING;
    if( animated !== false && animated !== true ) duration = animated;

    var thisThing = this;
    if( animated )
    {
      if( offsetX != null )
      {
        Animated.timing(this.state.offsetX,
        {
          toValue:offsetX,
          duration:duration
        }).start(()=>
        {
          if( thisThing._completion ) thisThing._completion();
        });
      }
      if( offsetY != null )
      {
        Animated.timing(this.state.offsetY,
        {
          toValue:offsetY,
          duration:duration
        }).start(()=>
        {
          if( thisThing._completion ) thisThing._completion();
        });
      }
    }
    else
    {
      var newState = {};
      if( offsetX != null )
      {
        newState.offsetX = new Animated.Value(offsetX);
        newState.offsetX.addListener(this.offsetXChanged);
        Animated.timing(newState.offsetX,
        {
          toValue:offsetX,
          duration:1
        }).start(()=>
        {
          if( thisThing._completion ) thisThing._completion();
        });
      }
      if( offsetY != null )
      {
        newState.offsetY = new Animated.Value(offsetY);
        newState.offsetY.addListener(this.offsetYChanged);
        Animated.timing(newState.offsetY,
        {
          toValue:offsetY,
          duration:1
        }).start(()=>
        {
          if( thisThing._completion ) thisThing._completion();
        });
      }
      this.props.onScroll(
        {
          nativeEvent:
          {
            contentOffset:
            {
              x: offsetX != null ? -offsetX : -this.state.offsetX.getValue(),
              y: offsetY != null ? -offsetY : -this.state.offsetY.getValue()
            }
          }
        }
      );
      this.setState(newState)
    }
  },

  offsetYChanged : function({value})
  {
    this.props.onScroll(
      {
        nativeEvent:
        {
          contentOffset:
          {
            x: -this.state.offsetX.getValue(),
            y: -this.state.offsetY.getValue()
          }
        }
      }
    );
  },

  offsetXChanged : function({value})
  {
    this.props.onScroll(
      {
        nativeEvent:
        {
          contentOffset:
          {
            x: -this.state.offsetX.getValue(),
            y: -this.state.offsetY.getValue()
          }
        }
      }
    );
  },

  render: function()
  {
    var {horizontal, style, children} = this.props;
    var otherProps = {};
    for( var key in this.props )
    {
      if( key != 'horizontal'
        && key != 'style'
        && key != 'children')
      {
        otherProps[key] = this.props[key];
      }
    }
    style = StyleSheet.flatten(style);

    return <View style={style} {...otherProps}>
      <Animated.View style={{position:'absolute', top:this.state.offsetY, left:this.state.offsetX, flex:-1, flexDirection : horizontal ? "row" : "column"}}>
      {this.props.children}
      </Animated.View>
    </View>
  }
});

module.exports = OffsetView;
